import React, { useContext, useRef } from 'react'
import { subPageBus } from './event'
import { MaxContext } from './context'

export const SubPage = (props: any) => {
  const container = useRef<HTMLDivElement>(null)
  const { pageCode } = useContext(MaxContext)

  const { style } = props

  return (
    <div
      ref={(node) => {
        container.current = node
        if (node) {
          subPageBus.emit(pageCode)
        } else {
          subPageBus.removeListener(pageCode)
        }
      }}
      style={style}
      className="max-render-sub-page"
      id={pageCode}></div>
  )
}
